import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "paperclipFilled"
const PaperclipFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M7.789 10.087C7.755 10.7 7.818 11.317 7.977 11.913L8.005 12.018 7.928 12.094 5.768 14.254C4.672 15.352 4.672 17.134 5.769 18.232 6.869 19.33 8.649 19.33 9.747 18.232L12.398 15.58C13.496 14.482 13.496 12.7 12.398 11.603 12.032 11.237 12.032 10.643 12.398 10.276 12.764 9.911 13.358 9.91 13.724 10.276 15.554 12.106 15.554 15.075 13.724 16.906L11.072 19.558C9.242 21.388 6.274 21.388 4.443 19.558S2.613 14.759 4.443 12.928L7.095 10.276Q7.283 10.09 7.485 9.93L7.811 9.668zM12.405 10.577Q12.418 10.551 12.434 10.527L12.437 10.523Q12.419 10.549 12.405 10.577"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M12.928 4.443C14.758 2.613 17.727 2.613 19.558 4.443S21.387 9.241 19.557 11.072L16.904 13.724Q16.717 13.91 16.515 14.07L16.189 14.332 16.211 13.915C16.245 13.3 16.183 12.684 16.024 12.087L15.994 11.982 16.073 11.906 18.232 9.746C19.33 8.648 19.33 6.867 18.232 5.77S15.352 4.671 14.254 5.77L11.603 8.42C10.504 9.52 10.504 11.3 11.603 12.398 11.968 12.764 11.969 13.358 11.603 13.724 11.236 14.09 10.643 14.09 10.276 13.724 8.446 11.894 8.446 8.925 10.276 7.094zM16.773 13.591Q16.593 13.77 16.398 13.925 16.496 13.846 16.59 13.765zM15.389 4.881C14.925 5.018 14.488 5.27 14.12 5.636Q14.176 5.58 14.233 5.53 14.406 5.375 14.593 5.252 14.716 5.17 14.847 5.102 14.913 5.065 14.98 5.035 15.113 4.974 15.25 4.926 15.32 4.901 15.39 4.881M16.889 3.304 16.919 3.309Q16.797 3.29 16.674 3.279z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PaperclipFilledIcon
